import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { TreasuryAccountsPage } from '../../features/finance/treasury-accounts-page'

export const Route = createFileRoute('/_app/cash-bank')({
  staticData: { crumb: 'cashBank' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'treasury.read'),
  component: TreasuryAccountsPage,
})
